import React from "react";
import { Box, Typography, Paper, CircularProgress } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";

interface ChildBusinessCountCardProps {
  count: number;
  loading: boolean;
}

const ChildBusinessCountCard: React.FC<ChildBusinessCountCardProps> = ({
  count,
  loading
}) => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 2,
        mb: 3,
        backgroundColor: "#f5f5f5"
      }}
    >
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        Child Businesses
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          alignItems: "center"
        }}
      >
        <BusinessIcon
          sx={{
            fontSize: 32,
            color: "#192F67"
          }}
        />
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <Typography variant="h5" sx={{ fontWeight: 600, color: "#192F67" }}>
            {count}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default ChildBusinessCountCard;
